import MegaLottery from "./mega-lottery/index";

export default MegaLottery;
